(() => {
  const actions = document.querySelector('[data-floating-actions]');
  if (!actions || actions.dataset.initialized) return;
  actions.dataset.initialized = 'true';
  const chat = actions.querySelector('[data-chat-launcher]');
  const top = actions.querySelector('[data-back-to-top]');

  if (top) {
    top.hidden = false;
    top.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      document.getElementById('MainContent')?.focus({ preventScroll: true });
    });
  }

  if (typeof window.zE !== 'function') return;
  // Use Zendesk's public API so the chat iframe and its contents keep their native size.
  window.zE('messenger', 'hide');
  chat.hidden = false;
  let openedFromLauncher = false;
  chat.addEventListener('click', () => {
    openedFromLauncher = true;
    window.zE('messenger', 'show');
    window.zE('messenger', 'open');
  });
  window.zE('messenger:on', 'open', () => {
    chat.setAttribute('aria-expanded', 'true');
    actions.hidden = true;
  });
  window.zE('messenger:on', 'close', () => {
    window.zE('messenger', 'hide');
    chat.setAttribute('aria-expanded', 'false');
    actions.hidden = false;
    if (openedFromLauncher) chat.focus({ preventScroll: true });
    openedFromLauncher = false;
  });
  window.zE('messenger:on', 'unreadMessages', count => {
    const badge = chat.querySelector('[data-chat-unread]');
    badge.hidden = count <= 0;
    badge.textContent = count > 99 ? '99+' : String(count);
    chat.setAttribute('aria-label', count > 0 ? `Chat with us (${count} unread messages)` : 'Chat with us');
  });
})();
